import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ContextService {
  constructor(private readonly _activatedRoute: ActivatedRoute) {}

  get isDsdContext(): boolean {
    return !!this.getDataValue('isDsdContext');
  }

  getDataValue(key: string): any {
    let currentRoute: ActivatedRoute = this._activatedRoute.root;
    while (currentRoute.children.length > 0) {
      currentRoute = currentRoute.firstChild;
      if (currentRoute && currentRoute.snapshot && currentRoute.snapshot.data && currentRoute.snapshot.data[key]) {
        return currentRoute.snapshot.data[key];
      }
    }

    return null;
  }
}
